var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[(_vm.screenWidth >= 1200)?_c('left-nav',{ref:"box"}):_vm._e(),_c('div',{staticClass:"right",style:({ width: _vm.screenWidth >= 1200 ? '81%' : '100%' })},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }